export const CAMELOT_ARBITRUM_ROUTER_CONTRACT_ADDRESS =
    '0x1F721E2E82F6676FCE4eA07A5958cF098D339e18';
